import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, onBeforeMount, onMounted, ref, watch } from 'vue'
// import { useRoute } from 'vue-router'
import FullScreenImage from '~/components/index/FullScreenImage.vue'
import LayoutBreadcrumbs from '~/components/layout/LayoutBreadcrumbs.vue'
import LayoutFooter from '~/components/layout/LayoutFooter.vue'
import LayoutHeader from '~/components/layout/LayoutHeader.vue'
import PaintingsBlock from '~/components/new/main-page/PaintingsBlock.vue'
// import PromoCodePopup from '~/components/popups/PromoCodePopup.vue'

import 'vue-toast-notification/dist/theme-bootstrap.css'


export default /*#__PURE__*/_defineComponent({
  __name: 'default',
  setup(__props) {

/* eslint-disable */
const instance = getCurrentInstance()

const route = instance?.proxy?.$route
const router = instance?.proxy.$router

const content = ref<HTMLDivElement>()
const isAnalyticaInit = ref(false)

const displayGallery = ref(!route.query?.page && (route?.path == '/'))

watch(displayGallery, (value, old) => {
  if (value === old) { return }

  router.replace({ path: '/', query: { page: value ? undefined : 'true' } })
})

onMounted(() => {
  window.addEventListener('mousemove', initAnalytica)
  window.addEventListener('scroll', initAnalytica)
})

onBeforeMount(() => {
  window.scroll({ top: 0 })
})

const initAnalytica = () => {
  if (!isAnalyticaInit.value) {
    isAnalyticaInit.value = true
    window.removeEventListener('mousemove', initAnalytica)
    window.removeEventListener('scroll', initAnalytica)

    const script = document.createElement('script')
    script.src = 'https://www.googletagmanager.com/gtag/js?id=UA-187763789-1'
    script.async = true
    document.getElementsByTagName('head')[0].appendChild(script)
  }
}

const safariScrollTop = () => {
  window.scrollTo({ top: 0 })
}
const toGalleryLinkHandler = () => {
  // @ts-ignore
  displayGallery.value = true

  // @ts-ignore
}
const toPageLinkHandler = async () => {
  // @ts-ignore
  displayGallery.value = false

  await instance?.proxy.$nextTick()

  displayGallery.value = null


  (instance?.proxy.$refs.page as HTMLElement).scrollIntoView({ block: 'start', behavior: 'smooth' })
}

return { __sfc: true,instance, route, router, content, isAnalyticaInit, displayGallery, initAnalytica, safariScrollTop, toGalleryLinkHandler, toPageLinkHandler, FullScreenImage, LayoutBreadcrumbs, LayoutFooter, LayoutHeader, PaintingsBlock }
}

})